import {
  FC,
  useState,
  useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import { Alert, Snackbar } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';

import { useTypedDispatch } from 'hooks/useTypedDispatch';
import { setMessage as setMessageApp } from 'store/app/appReducer';
import { messageSelector } from 'store/app/appSelectors';

const DURATION = 3000;

const TransitionDown = (props: SlideProps) => {
  return <Slide {...props} direction="down" />;
};

export const Message: FC = () => {
  const dispatch = useTypedDispatch();

  const appMessage = useSelector(messageSelector);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onClose = () => setIsOpen(false);

  useEffect(() => {
    if (appMessage == null) {
      return;
    }

    setIsOpen(true);
    setMessage(appMessage.message);
    dispatch(setMessageApp(null));
  }, [appMessage]);

  return (
    <Snackbar
      style={{ zIndex: 10001 }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isOpen}
      autoHideDuration={DURATION}
      onClose={onClose}
      TransitionComponent={TransitionDown}
    >
      <Alert
        onClose={onClose}
        severity="success"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
